import { render } from "./productive_vs_non_productive_logs_details.vue?vue&type=template&id=3f6f3918&scoped=true"
import script from "./productive_vs_non_productive_logs_details.vue?vue&type=script&lang=js"
export * from "./productive_vs_non_productive_logs_details.vue?vue&type=script&lang=js"

import "./productive_vs_non_productive_logs_details.vue?vue&type=style&index=0&id=3f6f3918&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6f3918"]])

export default __exports__